import type { LayoutSpec } from '../../../../types/LayoutConfig';
import { CHART_VIEWS_LAYOUT_ID, CHART_VIEWS_LAYOUT_TEMPLATE_ID } from '../tokens';
import { CHART_VIEWS_LAYOUT } from './ChartViews';

export const CHART_VIEWS_LAYOUT_SPEC: LayoutSpec = {
  templateId: CHART_VIEWS_LAYOUT_TEMPLATE_ID,
  label: 'Chart views',
  id: CHART_VIEWS_LAYOUT_ID,
  dockViewLayout: CHART_VIEWS_LAYOUT,
  constraints: [],
  collapsablePanels: [],
};
